/**
 * @flow
 */
'use strict';

export const pupilFormCodes = [
{"code":"Round"},
{"code":"Oval"},
{"code":"Irregular"}
]

export const pupilReactionCodes = [
{"code":"1"},
{"code":"2"},
{"code":"3"},
{"code":"4"},
{"code":"5"}
]

export const pupilMGunnCodes = [
{"code":"+"},
{"code":"-"}
]

export const pupilAccomodationCodes = [
{"code":"Reactive"},
{"code":"Non reactive"}
]

export const pupilDiagnoseCodes = [
{"code":"PERRLA"},
{"code":"PERRLA (-)RAPD"},
{"code":"RAPD / Marcus Gunn"},
{"code":"Argyll Robertson"},
{"code":"Adie's tonic pupil syndrome"},
{"code":"Horner's syndrome"},
{"code":"Pharmacologically dilated pupil"},
{"code":"Anisocoria"}
]

export const hirschbergCodes = [
{"code":"Ortho"},
{"code":"Esotropia"},
{"code":"Exotropia"},
{"code":"Hypertropia"},
{"code":"Hypotropia"},
]

export const brucknerCodes = [
{"code":"Deep red reflex"},
{"code":"Light red reflex"},
]
